import { httpClient } from '@/services/http/httpClient'
import { getTenantByCookies } from '@/utils/getTenantByCookies'

export type PortfolioHttpResponse = {
  investmentTotal: number
  revenueGainTotal: number
  effectiveRevenue: number
  potencialROI: number
}

type Portfolio = {
  portfolio: PortfolioHttpResponse
}

export async function getDashboardFinancialImpact(): Promise<Portfolio> {
  const tenant = await getTenantByCookies()

  if (tenant?.slug === 'trial') {
    await new Promise((resolve) => setTimeout(resolve, 1000))

    return {
      portfolio: {
        investmentTotal: 2150,
        revenueGainTotal: 3270,
        effectiveRevenue: 4710,
        potencialROI: 50,
      },
    }
  }

  const { data } = await httpClient.get<PortfolioHttpResponse>(
    '/ideas/dashboard/portfolio',
  )

  const { effectiveRevenue, investmentTotal, potencialROI, revenueGainTotal } =
    data

  return {
    portfolio: {
      investmentTotal: investmentTotal ?? 0,
      revenueGainTotal: revenueGainTotal ?? 0,
      effectiveRevenue: effectiveRevenue ?? 0,
      potencialROI: potencialROI ?? 0,
    },
  }
}
